module.exports = __webpack_public_path__ + "static/media/icon_drawer_switcher.aaa622f7.svg";